<template>
  <div class="columns">
    <div class="column">
      <b-field :label="entry.course ? 'Curso' : ''" label-position="on-border">
        <b-autocomplete
          v-model="entry.course"
          expanded
          :data="filteredCoursesArray"
          :open-on-focus="true"
          :keep-first="true"
          placeholder="Curso (Ex: Administração)"
          @select="option => (selected = option)"
        >
          <template slot="empty">Sem resultados</template>
        </b-autocomplete>
      </b-field>
    </div>

    <div class="column">
      <b-field
        :label="entry.quantity ? 'Quantidade' : ''"
        label-position="on-border"
      >
        <b-input
          v-model="entry.quantity"
          placeholder="Quantidade (Ex: 10)"
          expanded
          type="number"
        ></b-input>

        <button class="button" type="button" @click="$emit('add-entry')">
          +
        </button>

        <button
          class="button"
          type="button"
          @click="$emit('remove-entry', index)"
        >
          -
        </button>
      </b-field>
    </div>
  </div>
</template>

<script>
import { cursos } from "../../assets/js/cursos";

export default {
  props: ["entry", "index"],

  data() {
    return {
      coursesList: []
    };
  },

  computed: {
    filteredCoursesArray() {
      let filteredCoursesArray = [];
      filteredCoursesArray = this.coursesList.filter(option => {
        return (
          option
            .toString()
            .toLowerCase()
            .indexOf(this.entry.course.toLowerCase()) >= 0
        );
      });
      return filteredCoursesArray;
    }
  },

  mounted() {
    this.coursesList = cursos;
  }
};
</script>
